import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
// import { LoaderComponent } from "../../../Common/LoaderComponent";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);

  // const fetchData = () => {
  //   Http.get("/distributor").then((res) => {
  //     setReceiveData(res.data);
  //   });
  // };

  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const res = await Http.get(`/distributor`);
      setReceiveData(res.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };

  const cols = [
    { field: "code", header: "CODE" },
    { field: "name", header: "NAME" },
    { field: "factory.name", header: "DEPOT" }, // Assuming 'factory' is an object within each distributor and 'name' is the depot name
    { field: "business_type", header: "TYPE" },
    { field: "sr_base_info.status", header: "SR" }, // Assuming 'sr_base_info' is an object and 'status' indicates the SR status
    { field: "distributor_workplace.region.name", header: "REGION" }, // Assuming 'region' is nested under 'distributor_workplace' and has a 'name' property
    { field: "distributor_workplace.area.name", header: "AREA" }, // Similar to 'REGION'
    { field: "distributor_workplace.base.name", header: "BASE" }, // Assuming 'base' is nested under 'distributor_workplace'
    { field: "status", header: "STATUS" },
    {
      field: "balance",
      header: "BALANCE",
      format: (value) => value.toFixed(2),
    }, // Assuming you want to format the balance as a decimal
  ];

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Distributors</h5>
            <Link to="/create-distributors" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i>New
            </Link>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              {/* <h6 className="card-body-title mg-sm-b-30">Datatable</h6> */}
              {/* <div className="row">
                <div className="table-responsive p-0 pb-2">
                  <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 datatable">
                    <thead>
                      <tr>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          S/N
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Code
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Name
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Depot
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Type
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          SR
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Region
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Area
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Base
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Status
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Balance
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {receiveData.map((item, index) => (
                        <tr key={item.id}>
                          <td className="text-xs">{index + 1}</td>
                          <td className="text-xs">{item.code}</td>
                          <td className="text-xs">
                            <Link
                              to={{
                                pathname: "/distributor-details/" + item.id,
                              }}
                              title="Distributor Details"
                            >
                              {item.name}
                            </Link>
                          </td>
                          <td className="text-xs">
                            {item.factory ? item.factory.name : ""}
                          </td>
                          <td className="text-xs">{item.business_type}</td>
                          <td className="text-xs">
                            {item.sr_base_info
                              ? item.sr_base_info.map((item2, index2) =>
                                  item2.base ? (
                                    <span
                                      key={index2}
                                      className="badge bg-secondary me-1"
                                      style={{
                                        fontSize: "80%",
                                        fontWeight: 300,
                                      }}
                                    >
                                      {item2.base.user
                                        ? item2.base.user.name
                                        : ""}
                                    </span>
                                  ) : (
                                    ""
                                  )
                                )
                              : ""}
                          </td>
                          <td className="text-xs">
                            {item.distributor_workplace
                              ? item.distributor_workplace.map(
                                  (item2, index2) =>
                                    item2.region ? (
                                      <span
                                        key={index2}
                                        className="badge bg-secondary me-1"
                                        style={{
                                          fontSize: "80%",
                                          fontWeight: 300,
                                        }}
                                      >
                                        {item2.region.name}
                                      </span>
                                    ) : (
                                      ""
                                    )
                                )
                              : ""}
                          </td>
                          <td className="text-xs">
                            {item.distributor_workplace
                              ? item.distributor_workplace.map(
                                  (item2, index2) =>
                                    item2.area ? (
                                      <span
                                        key={index2}
                                        className="badge bg-secondary me-1"
                                        style={{
                                          fontSize: "80%",
                                          fontWeight: 300,
                                        }}
                                      >
                                        {item2.area.name}
                                      </span>
                                    ) : (
                                      ""
                                    )
                                )
                              : ""}
                          </td>
                          <td className="text-xs">
                            {item.distributor_workplace
                              ? item.distributor_workplace.map(
                                  (item2, index2) =>
                                    item2.base ? (
                                      <span
                                        key={index2}
                                        className="badge bg-secondary me-1"
                                        style={{
                                          fontSize: "80%",
                                          fontWeight: 300,
                                        }}
                                      >
                                        {item2.base.name}
                                      </span>
                                    ) : (
                                      ""
                                    )
                                )
                              : ""}
                          </td>
                          <td className="text-xs text-right">
                            <span
                              className={`badge ${
                                item.status === "active"
                                  ? "bg-primary"
                                  : "bg-danger"
                              } me-1`}
                              style={{
                                fontSize: "80%",
                                fontWeight: 300,
                              }}
                            >
                              {item.status}
                            </span>
                          </td>
                          <td className="text-xs text-right">
                            {parseFloat(item.balance).toFixed(2)}
                          </td>
                          <td className="text-xs">
                            <Link
                              to={{
                                pathname: "/edit-distributors/" + item.id,
                              }}
                              className="btn btn-primary btn-sm ml-1"
                            >
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                              ></i>
                            </Link>
                            <button
                              className="btn btn-danger btn-sm ms-1"
                              onClick={() =>
                                deleteData(
                                  item.id,
                                  "distributors",
                                  "distributors"
                                )
                              }
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div> */}
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                actionTemplate={actionTemplate}
                deleteData={deleteData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const actionTemplate = (item, deleteData) => {
  return (
    <td className="text-xs">
      <Link
        to={{
          pathname: "/edit-distributors/" + item.id,
        }}
        className="btn btn-primary btn-sm ml-1"
      >
        <i className="fa fa-pencil" aria-hidden="true"></i>
      </Link>
      <Link
        to={{
          pathname: "/distributor-details/" + item.id,
        }}
        className="btn btn-success btn-sm ms-1"
        title="Distributor Details"
      >
        <i className="fa fa-user"></i>
      </Link>

      <button
        className="btn btn-danger btn-sm ms-1"
        onClick={() => deleteData(item.id, "distributors", "distributors")}
      >
        <i className="fa fa-trash"></i>
      </button>
    </td>
  );
};

export default List;
